import React from 'react'
import getUserInitials from '../../utils/getUserInitials'

function ProfilePicture({
  user,
  small,
  big,
  className
}) {
  return (
    <>
    {!user.profile_pic_url &&
      <div className={`rounded-full ${!small && !big && 'h-12 w-12 text-xl'} ${small && 'h-9 w-9 text-sm'} ${big && 'h-20 w-20 text-3xl'} ${className} bg-primary-lightplus flex justify-center items-center text-white font-bold`}>
        {user.first_name && user.last_name && getUserInitials(user.first_name, user.last_name)}
        {(!user.first_name || !user.last_name) && ''}
      </div>}
      {user.profile_pic_url &&
      <div>
        <img className={`${!small && !big && 'h-12 w-12'} ${small && 'h-9 w-9'} ${big && 'h-20 w-20 text-3xl'} ${className} rounded-full overflow-hidden transform scale-100`} src={user.profile_pic_url} alt=''/>
      </div>}
    </>
    
  )
}

export default ProfilePicture
